/**
 * @generated SignedSource<<31eb09570177dcacd54b9bb00afd5d00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProviderInfoCardGallery_images$data = ReadonlyArray<{
  readonly transformedSrc: string;
  readonly " $fragmentType": "ProviderInfoCardGallery_images";
}>;
export type ProviderInfoCardGallery_images$key = ReadonlyArray<{
  readonly " $data"?: ProviderInfoCardGallery_images$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProviderInfoCardGallery_images">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProviderInfoCardGallery_images",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "maxHeight",
          "value": 300
        },
        {
          "kind": "Literal",
          "name": "maxWidth",
          "value": 640
        }
      ],
      "kind": "ScalarField",
      "name": "transformedSrc",
      "storageKey": "transformedSrc(maxHeight:300,maxWidth:640)"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "f9dfac78be0d67bd00269729c141419d";

export default node;
